import React, { memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components/native";

import { getThankyouProps } from "state/modules/feedback/selectors";
import { fillPlaceholders } from "state/modules/survey/selectors";
import { useSurveyTheme } from "screens/question/hooks";
import { MarkdownText } from "components";
import { PoweredByContainer } from "components/poweredByContainer/index";
import {
  setSurveyStatus,
  setSurveyMessage,
} from "state/modules/survey/actions";

import {
  Container,
  BgImage,
  ImageHolder,
  LogoImage,
  TextHolder,
  WelcomeText,
  ThankYouImageContainer,
  ThankYouImage,
} from "screens/main/themeB/styled";

import { styles } from "./styles";

const ThankYou = memo(
  () => {
    const { logo, background, theme } = useSurveyTheme();
    let { image, message } = useSelector(getThankyouProps);
    message = useSelector(state => fillPlaceholders(message, state));
    const state = useSelector(state => state);
    const feedback_status = state.feedback.status;

    if (!feedback_status["status"]) {
      const dispatch = useDispatch();
      dispatch(setSurveyStatus("expired"));
      dispatch(setSurveyMessage(feedback_status["message"]));
    }

    return (
      <ThemeProvider theme={theme}>
        <Container>
          <BgImage source={background} />
          {image ? (
            <ThankYouImageContainer>
              <ThankYouImage source={image} />
            </ThankYouImageContainer>
          ) : (
            <ImageHolder>
              <LogoImage source={logo} />
            </ImageHolder>
          )}
          <TextHolder $isThankYou={!!image}>
            <WelcomeText>
              <MarkdownText>{message}</MarkdownText>
            </WelcomeText>
          </TextHolder>
          <PoweredByContainer
            style={styles.poweredByContainer}
            logo={state.organization.powered_by_logo}
            url={state.organization.powered_by_url}
          />
        </Container>
      </ThemeProvider>
    );
  },
  () => true,
);

export default ThankYou;
